/**
 * GA4 event helpers — property G-CJRWZCMLRW loaded in public/index.html.
 */

const GA4_MEASUREMENT_ID = 'G-CJRWZCMLRW';

function gtagSafe(...args) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag(...args);
}

function attributionParams(snapshot) {
  if (!snapshot || typeof snapshot !== 'object') return {};
  const src = snapshot.checkout || snapshot.last_touch || snapshot;
  return {
    utm_source: src.utm_source || undefined,
    utm_medium: src.utm_medium || undefined,
    utm_campaign: src.utm_campaign || undefined,
    utm_content: src.utm_content || undefined,
    utm_term: src.utm_term || undefined,
    gclid: src.gclid || undefined,
    gbraid: src.gbraid || undefined,
    wbraid: src.wbraid || undefined,
    source_classification: src.source_classification || snapshot.source_classification || undefined,
    landing_page: snapshot.landing_page || src.landing_page || undefined,
  };
}

export function setAnalyticsUserId(uid) {
  if (!uid) return;
  gtagSafe('config', GA4_MEASUREMENT_ID, { user_id: uid });
}

export function clearAnalyticsUserId() {
  gtagSafe('config', GA4_MEASUREMENT_ID, { user_id: null });
}

/**
 * @param {'google'|'email'|'link'} method
 * @param {object} [attributionSnapshot]
 */
export function trackSignUp(method, attributionSnapshot) {
  gtagSafe('event', 'sign_up', {
    method,
    ...attributionParams(attributionSnapshot),
  });
}

/**
 * @param {object} params
 * @param {string} params.planId
 * @param {string} params.planName
 * @param {number} params.value
 * @param {string} [params.currency]
 * @param {string} [params.paymentProvider]
 * @param {object} [params.attributionSnapshot]
 */
export function trackBeginCheckout({
  planId,
  planName,
  value,
  currency = 'USD',
  paymentProvider,
  attributionSnapshot,
}) {
  gtagSafe('event', 'begin_checkout', {
    currency,
    value,
    payment_provider: paymentProvider || undefined,
    items: [
      {
        item_id: planId,
        item_name: planName || planId,
        price: value,
        quantity: 1,
      },
    ],
    ...attributionParams(attributionSnapshot),
  });
}

/**
 * @param {object} params
 */
export function trackPurchase({
  transactionId,
  value,
  currency = 'USD',
  planId,
  planName,
  paymentProvider,
  attributionSnapshot,
}) {
  gtagSafe('event', 'purchase', {
    transaction_id: transactionId,
    currency,
    value,
    payment_provider: paymentProvider || undefined,
    items: [
      {
        item_id: planId,
        item_name: planName || planId,
        price: value,
        quantity: 1,
      },
    ],
    ...attributionParams(attributionSnapshot),
  });
}

export { GA4_MEASUREMENT_ID };
